"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var react_final_form_1 = require("react-final-form");
var LineButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/LineButton"));
var Table_1 = __importDefault(require("atomicComponents/atoms/Table/Table"));
var TableBody_1 = __importDefault(require("atomicComponents/atoms/Table/TableBody"));
var AddInCCRow_1 = __importDefault(require("./AddInCCRow"));
var CCEmailRow_1 = __importDefault(require("./CCEmailRow"));
var Header_1 = __importDefault(require("./Header"));
var CCEmail = function () {
    var _a = (0, react_final_form_1.useField)('extraFakeCcEmails', { subscription: { value: true } }).input, extraFakeCcEmails = _a.value, onChange = _a.onChange;
    var canDelete = extraFakeCcEmails.length > 1;
    var addRow = function () { return onChange(__spreadArray(__spreadArray([], __read(extraFakeCcEmails), false), [{}], false)); };
    var deleteRow = function (idxToRm) { return onChange(extraFakeCcEmails.filter(function (v, idx) { return idxToRm !== idx; })); };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Header_1.default, { heading: "CC email address", description: "You can optionally choose to be CC\u2019ed in some of the outgoing emails to your customers.\n          You can use several emails." }), (0, jsx_runtime_1.jsx)(Table_1.default, __assign({ sizing: "dense" }, { children: (0, jsx_runtime_1.jsxs)(TableBody_1.default, { children: [(0, jsx_runtime_1.jsx)(react_final_form_1.FormSpy, __assign({ subscription: { values: true } }, { children: function (_a) {
                                var values = _a.values;
                                return (values.contact && values.addContactInCc
                                    ? (0, jsx_runtime_1.jsx)(AddInCCRow_1.default, { email: values.contact.email, name: values.contact.name })
                                    : null);
                            } })), extraFakeCcEmails.map(function (row, idx) { return ((0, jsx_runtime_1.jsx)(CCEmailRow_1.default, { handleDelete: function () { return deleteRow(idx); }, canDelete: canDelete, name: "extraFakeCcEmails[".concat(idx, "]") }, idx)); })] }) })), !(0, isEmpty_1.default)(extraFakeCcEmails.at(-1)) && ((0, jsx_runtime_1.jsx)(LineButton_1.default, __assign({ size: "small", color: "neutral", onClick: addRow, sx: { mt: 1.25 } }, { children: "Add CC email" })))] }));
};
exports.default = CCEmail;
